var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "h3",
      { staticClass: "title", attrs: { content: "edit", placement: "bottom" } },
      [_vm._v("\n    Campaign Management - Campaign Popup\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "client-panel" },
      [
        _c(
          "div",
          { staticClass: "client-panel__toolbar" },
          [
            _c("columns-control", {
              attrs: {
                columns: _vm.columnsConfig,
                "storage-key": "cms.campaignManagement.columns"
              },
              on: { change: _vm.onColumnsChange }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          { attrs: { data: _vm.tableData } },
          [
            _vm.isColumnVisible("salesOffice")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "salesOffice",
                    label: "Sales Office",
                    width: "600"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.salesOfficeMap(
                                  scope.row.salesOffice
                                )
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4066695550
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("title")
              ? _c("el-table-column", {
                  attrs: { prop: "title", label: "Title" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("postOnline")
              ? _c("el-table-column", {
                  attrs: { prop: "postOnline", label: "Post" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.postOnline ? "Online" : "Offline"
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3010489729
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("updatedAt")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "updatedAt",
                    label: "Last update",
                    formatter: _vm.$commonjs.tableFormatDateTime
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Operation" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "Edit",
                            placement: "top"
                          }
                        },
                        [
                          _c("em", {
                            staticClass: "edit",
                            staticStyle: { "margin-right": "10px" },
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.row)
                              }
                            }
                          })
                        ]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f1273d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1273d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification/campaign.vue
// module id = null
// module chunks = 